import React, { Component } from 'react';
import {
  Card,
  CardTitle,
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn
} from 'material-ui';
import { sprintf } from 'sprintf-js';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Card>
        <CardTitle title="Overview" />
        <Table>
          <TableHeader
            displayRowCheckbox={false}
            adjustForCheckbox={false}
            displaySelectAll={false}
          >
            <TableRow>
              <TableHeaderColumn>Days Number</TableHeaderColumn>
              <TableHeaderColumn>
                Avg. number of motivated calls
              </TableHeaderColumn>
              <TableHeaderColumn>
                Avg. positive agreements (#)
              </TableHeaderColumn>
              <TableHeaderColumn>
                Avg. positive agreements (%)
              </TableHeaderColumn>
              <TableHeaderColumn>Avg. Increase</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            <TableRow>
              <TableRowColumn>{this.state.callDays}</TableRowColumn>
              <TableRowColumn>
                {sprintf(
                  '%0.2d',
                  ~~this.state.motivatedCalls / ~~this.state.callDays
                )}
              </TableRowColumn>
              <TableRowColumn>
                {sprintf(
                  '%0.2d',
                  this.state.positiveAgreement / this.state.callDays
                )}
              </TableRowColumn>
              <TableRowColumn>
                {sprintf(
                  '%0.2d%%',
                  this.state.motivatedCalls
                    ? this.state.positiveAgreement / this.state.motivatedCalls
                    : 0
                )}
              </TableRowColumn>
              <TableRowColumn>
                {sprintf(
                  '%0.2d',
                  this.state.increasesTotal / this.state.callDays
                )}
              </TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
    );
  }
}

export default Overview;



// WEBPACK FOOTER //
// ./src/Overview.js